import { GET_POST_UPDATE_STATUS, UPDATE_POST } from './operations'
import type { TPostMutationsMap, TPostQueriesMap } from './types'

export const GRAPHQL_POST_MUTATIONS: TPostMutationsMap = {
  updatePost: UPDATE_POST,
}

export const GRAPHQL_POST_QUERIES: TPostQueriesMap = {
  getPostUpdateStatus: GET_POST_UPDATE_STATUS,
}
